<template>
  <div>
    <static-alert v-if="message" :message="message" @on-hide="message=''" />

    <div class="d-flex gap-4 mb-3 d-none">
      <div><span class="bi bi-1-circle me-1"></span> Authorize eBay</div>
      <span class="bi bi-arrow-right"></span>
      <div><span class="bi bi-2-circle me-1"></span> Connect eBay</div>
      <span class="bi bi-arrow-right"></span>
      <div><span class="bi bi-3-circle me-1"></span> Import eBay</div>
    </div>

    <hr>

    <transition mode="out-in">
      <loading-spinner v-if="fetching" class="m-3" />

      <div v-else-if="validRefresh">
        <div class="lead mb-3">
          <i class="bi bi-check-circle text-success me-2"></i>
          eBay Account Authorized.
        </div>

        <div v-if="eBayStatus?.needsReauth" class="alert alert-warning d-flex align-items-start gap-3 mb-3">
          <i class="bi bi-arrow-clockwise fs-5 mt-1"></i>
          <div>
            <div class="fw-semibold mb-1">Updated permissions needed</div>
            <p class="mb-2 small">New features (automatic return detection, marketing data, and more) require refreshed eBay permissions. Reconnecting takes less than a minute.</p>
            <connection-ebay />
          </div>
        </div>

        <ebay-shop-import v-if="!code && importable" @on-error="setMessage" @on-completed="onCompleted" :e-bay-status="eBayStatus" />

      </div>
      <div v-else-if="code" class="mb-3">
        <loading-spinner :small="true" />
        Authenticating...
      </div>
      <div v-else-if="!hasAccess">
        <coming-soon />
      </div>
      <div v-else class="mb-5">
        <div class="d-flex align-items-center mb-3">
          <div class="lead me-3">
          <i class="bi bi-check-circle text-success me-2"></i>
          Account Created
            </div>
          <span class="badge bg-success ms-auto">COMPLETE</span>
        </div>
        <p class="mb-3 ms-5">Your account is verified &amp; ready. Next, connect your eBay store so we can pull your sales data.</p>

        <hr>

        <div class="lead mb-3 text-info">
          <i class="bi bi-2-circle me-2"></i>
          Connect eBay
        </div>

        <div class="ms-5">
          <p>Connect your eBay account to authorize data access and sync your store.</p>
          <connection-ebay />
        </div>

        <hr>

        <div class="lead mb-5 text-muted">
          <i class="bi bi-3-circle me-2"></i>
          Import Recent Sales
        </div>
      </div>
    </transition>

    <pre class="d-none small">{{ eBayStatus }}</pre>

  </div>
</template>

<script setup>
import {computed, ref, defineProps} from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";
import ConnectionEbay from "@/app/components/ebay/ConnectionEbay.vue";
import StaticAlert from "@/app/components/Utils/StaticAlert.vue";
import EbayShopImport from "@/app/components/ebay/EbayShopImport.vue";
import ComingSoon from "@/app/components/Utils/ComingSoon.vue";

const store = useStore()
const route = useRoute()
const router = useRouter()

defineProps(['importable'])

const ebayUserToken = ref()
const validToken = ref(false)
const fetching = ref(false)
const message = ref('')

const validRefresh = computed(() => eBayStatus.value?.authenticated) // store.getters['eshop/validEbayRefreshToken']
const hasAccess = computed(() => store.getters.hasAccess)
const code = route.query.code || null

if (code) {
  getToken()
} else {
  checkEbay()
}

function setToken(token) {
  ebayUserToken.value = token.token
  validToken.value = token.validToken
  fetching.value = false
  if (token.error) {
    message.value = token.error
    console.log('get token error', token.error)
  }
}

function setMessage(msg) {
  message.value = msg
}

function getToken() {
  store.dispatch('eshop/getEbayUserToken', {code, type: 'code'})
      .then(checkEbay)
    .catch(error => {
      message.value = error.response?.data || error.message || error
      setToken({validToken: false, token:null, error})
    })
}

const eBayStatus = computed(() => store.state.eBayStatus)

function onCompleted() {
  window.location = '/'
}

async function checkEbay() {
  fetching.value = true
  await store.dispatch("eshop/getEbayConnectionState")
  if (code && eBayStatus.value?.authenticated) {
    if (eBayStatus.value?.eshop?.status === 'ACTIVE') {
      await router.replace({name: 'Welcome'})
    } else {
      window.location = '/'
    }
  }

  fetching.value = false
}
</script>

<style scoped>

</style>
